<template>
  <div id="output" class="flex h-100 flex-wrap pagebgd">
    <div @click="back()" class="power">
      <i style="cursor: pointer; font-size: 0.5rem" class="el-icon-back"></i>
    </div>
    <div class="etime">{{ now }}</div>
    <div class="etime1">最后更新:{{ updateTimeText }}</div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />
      <div class="font-big font-weight light-title">
        {{ title }}
      </div>
    </header>
    <div style="padding: 5px;width:100%;height:100%;" class="frcar">
      <div style="text-align:right;widht:100%">
        <el-button @click="openFilterModal()" size="mini" type="primary" icon="el-icon-edit">筛选入口</el-button>
      </div>
      <el-carousel ref="elCarousel" arrow="never" style="width: 100%; height:100%;" :autoplay="false"
        direction="vertical">
        <el-carousel-item style="width: 100%; height:100%;" v-for="(carou, idx)  in screen" :key="carou + idx">
          <div class="w-100 h-90" style="padding:10px">
            <table class="table-wrapper">
              <thead>
                <tr
                  style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
                  <th style="width:2%">No</th>
                  <th style="width:6%">发现日期</th>
                  <th style="width:6%">发起人</th>
                  <th style="width:6%">类别</th>
                  <th style="width:29%">问题描述</th>
                  <th style="width:29%">解决措施</th>
                  <th style="width:6%">负责人</th>
                  <th style="width:8%">计划关闭时间</th>
                  <th style="width:8%">实际关闭时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="leftValue.length < 1">
                  <td colspan="9">
                    <div style="text-align: center; margin: 20px;width: 100%;">
                      <h1 style="color: white; font-size: 20px">没有进行中的数据!</h1>
                    </div>
                  </td>
                </tr>
                <template v-for="(tr, ind) in dataSlice(carou, leftValue)">
                  <tr :key="'leftValue-' + ind">
                    <td>{{ ((idx * pageSize) + ind + 1) }}</td>
                    <td>{{ formatDate(tr.openDate) }}</td>
                    <td>
                      <span v-if="tr.creators">{{ tr.creators.name }}</span>
                    </td>
                    <td>
                      {{ statusMap[tr.trackingCategory] }}
                    </td>
                    <td>
                      <div style="padding:0.13rem;text-align:left">
                        <span v-html="tr.findding"></span>
                      </div>
                    </td>
                    <td>
                      <div style="padding:0.13rem;text-align:left">
                        <span v-html="tr.actions"></span>
                      </div>
                    </td>
                    <td>
                      <span v-if="tr.owner">{{ tr.owner.name }}</span>
                    </td>
                    <td><span :class="{ ['rowInfm']: diffInDays(tr) }">{{ formatDate(tr.planCloseDate) }}</span></td>
                    <td>{{ formatDate(tr.actCloseDate) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <el-dialog title="条件筛选" @close="closeModal()" :close-on-click-modal="false" :visible.sync="dialogFormVisible"
      width="50%">
      <el-form :rules="formRules" ref="form" size="small" :model="form" label-width="120px">
        <el-row :gutter="22">
          <el-col :span="24">
            <el-form-item prop="date" label="发现日期:">
              <el-date-picker v-model="form.date" style="width:100%" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="lineUUID" label="产线：">
              <el-select v-model="form.lineUUID" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in lineList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="trackingCategory" label="类别">
              <el-select v-model="form.trackingCategory" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option :label="'客户8D措施转入'" :value="'1'"></el-option>
                <el-option :label="'DDR'" :value="'2'"></el-option>
                <el-option :label="'客户审核问题'" :value="'3'"></el-option>
                <el-option :label="'客户反馈的问题'" :value="'4'"></el-option>
                <el-option :label="'ECR问题'" :value="'5'"></el-option>
                <el-option :label="'外部审核'" :value="'6'"></el-option>
                <el-option :label="'内部审核'" :value="'7'"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="owner" label="责任人：">
              <el-input v-model="form['owner.name']" style="width: 100%"></el-input>
              <!-- <el-select v-model="form.owner" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in deptList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="actCloseDate" label="报告状态">
              <el-select v-model="form.actCloseDate" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option :label="'进行中'" :value="1"></el-option>
                <el-option :label="'已关闭'" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="pageSize" label="显示条数：">
              <el-input-number v-model="form.pageSize" style="width: 140px" controls-position="right" :precision="0"
                :min="1"></el-input-number>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item prop="keyword" label="关键字">
              <el-input v-model="form.keyword" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="9">
            <el-button type="primary" size="small" @click="okFilter()" icon="search">
              确认
            </el-button>
            <el-button type="danger" v-if="!form.uuid" size="small" icon="reload" @click="resetForm()"
              style="margin-left: 2px">重置筛选</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../router";
import format from "date-fns/format";
export default {
  me: "main-output",
  data() {
    return {
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      logoSrc: "/assets/img/logo_light.png",
      title: "客户/审核问题追踪表",
      msg: "home",
      leftHeader: [], // 表头;
      leftValue: [], // 值;
      rightTopHeader: [], // 表头;
      rightTwoHeader: [], // 二级表头;
      rightValue: [], // 值;
      loading: null,
      dialogFormVisible: false,
      issueDialog: false,
      todoDialog: false,
      issueData: {},
      todoData: {},
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      screen: 1,
      pageSize: 8,
      zIndex: 0,
      too: 10000,
      now: null,
      week: null,
      updateTimeText: null,
      statusMap: { '1': '客户8D', '2': 'DDR', '3': '客户审核', '4': '客户反馈', '5': 'ECR','6': '外部审核','7': '内部审核'},
      deptList: [],
      form: {
        date: null,
        actCloseDate: null,
        trackingCategory: null,
        'owner.name': null,
        keyword: null,
      },
      filtersParams: {
        'owner.name': null,
        trackingCategory: null,
        actCloseDate: null,
        startTime: null,
        endTime: null,
        keyword: null,
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      formRules: {

      }
    };
  },
  mounted() {
    this.onShow();
    this.loadBoardTitle();
    this.loadOptions();
    this.webSocket();
    this.init(); //保留http
    //钟表
    setInterval(this.clock, 1000);

    //监听按键
    document.addEventListener('keyup', this.keyup);
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
    document.removeEventListener('keyup', this.keyup);
  },
  filters: {},
  methods: {
    keyup(e) {
      if (e.keyCode == 37 || e.keyCode == 38) {
        //上页 上箭头 左箭头
        var index = this.zIndex;
        if (index > 0) {
          this.zIndex = index - 1;
          this.$refs.elCarousel.setActiveItem(this.zIndex);
        } else {
          window.parent.postMessage('prev', '*');
          this.zIndex = 0;
          this.$refs.elCarousel.setActiveItem(this.zIndex);
        }
      } else if (e.keyCode == 39 || e.keyCode == 40) {
        //下页 下箭头 右箭头
        var index = this.zIndex;
        if (this.screen > (index + 1)) {
          this.zIndex = index + 1;
          this.$refs.elCarousel.setActiveItem(this.zIndex);
        } else {
          window.parent.postMessage('next', '*');
          this.zIndex = 0;
          this.$refs.elCarousel.setActiveItem(this.zIndex);
        }
      } else if (e.keyCode == 32) {

      }
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
    loadOptions() {
      //加载配置项列表
      var that = this;
      API.loadOrgDept()
        .then((res) => {
          if (res.success === true) {
            this.deptList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
    },
    resetForm() {
      this.form = {
        date: null,
        actCloseDate: null,
        trackingCategory: null,
        'owner.name': null,
        keyword: null,
      }
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },

    init() {
      this.leftHeader = ["Product", "项目", "频次", "状态"];
      this.loadData(false);
    },
    diffInDays(row) {
      if (row.planCloseDate) {
        var now = new Date();
        var s = now.setHours(0, 0, 0, 0) - 100;
        return row.planCloseDate < s && row.actCloseDate < 1000;
      }
      return true;
    },
    dataSlice(index, data) {
      var open = (index - 1) * this.pageSize;
      var end = index * this.pageSize;
      return data.slice(open, end);
    },
    loadData(filter) {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        var params = {};
        var query = {};

        Object.assign(query, this.filtersParams);
        if (query['startTime']) {
          var start = query['startTime'].setHours(0, 0, 0, 0);
          var end = query['endTime'].setHours(23, 59, 59, 0);;
          query['openDate'] = { '$between': [start, end] };
          delete query['startTime'];
          delete query['endTime'];
          delete query['date'];
        } else {
          delete query['startTime'];
          delete query['endTime'];
          delete query['date'];
        }

        if (query['actCloseDate'] == 1) {
          query['actCloseDate'] = { '$lt': 1 };
        } else if (query['actCloseDate'] == 2) {
          query['actCloseDate'] = { '$gt': 0 };
        } else {
          if (!filter) {
            query['actCloseDate'] = { '$lt': 1 };
          } else {
            delete query['actCloseDate'];
          }
        }

        if (query['trackingCategory'] === "") {
          delete query['trackingCategory'];
        }

        var queryParams = JSON.stringify(query);
        queryParams = encodeURIComponent(queryParams);
        params['query'] = query;
        console.log(query);

        // 加载
        this.startLoading();

        API.getFrTrackingList(queryParams)
          .then((res) => {
            if (res.success === true) {
              this.format(res);
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },
    //格式化数据
    format(res) {
      for (var i = 0; i < res.list.length; i++) {
        if (res.list[i]['findding']) {
          res.list[i]['findding'] = res.list[i]['findding'].replaceAll('\n', '<br/>');
        }
        if (res.list[i]['actions']) {
          res.list[i]['actions'] = res.list[i]['actions'].replaceAll('\n', '<br/>');
        }
      }

      this.leftValue = [];
      this.leftValue = res.list;
      // this.leftValue = this.leftValue.concat(this.leftValue);
      this.screen = Math.ceil(this.leftValue.length / this.pageSize);
      if (this.screen < 1) {
        this.screen = 1;
      }
      this.endLoading();
      var now = new Date();
      this.updateTimeText = format(now, "MM-dd HH:mm:ss");
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/oee/plan/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/oee/plan/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("OEE socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("OEE socket 连接失败");
      this.reconnect();
    },
    closeModal() {
      this.dialogFormVisible = false;
    },
    okFilter() {
      Object.assign(this.filtersParams, this.form);
      if (this.form['date'] && this.form['date'].length > 0) {
        this.filtersParams['startTime'] = this.form['date'][0];
        this.filtersParams['endTime'] = this.form['date'][1];
      } else {
        this.filtersParams['startTime'] = null;
        this.filtersParams['endTime'] = null;
      }
      this.closeModal();
      this.loadData(true);
    },
    openFilterModal() {
      this.dialogFormVisible = true;
      Object.assign(this.form, this.filtersParams);
      if (this.filtersParams.startTime && this.filtersParams.endTime) {
        this.form['date'] = [this.filtersParams.startTime, this.filtersParams.endTime];
      }
    },
    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" OEE socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>
<style>
.pagebgd {
  background: url("../../../assets/img/8dbg.png");
}

.frcar .el-carousel__indicators--vertical {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99;
}

.frcar .el-carousel__indicator {
  float: left;
}

.frcar .el-carousel__indicator--vertical .el-carousel__button {
  width: 30px;
  height: 10px;
}

#output {
  overflow-y: auto
}

#output::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}

#output::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #909090;
}

#output::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #EDEDED;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/trackinglist/board.vue